import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import { getTripsDetails } from "./functions";
import Glyphicon from "../Glyphicon";

class InfoWindowListaWyjazdow extends PureComponent<any> {
  static contextType = AppContext;

  render() {
    const { trips } = this.props;
    const { trips: allTrips } = this.context;
    const tripsList = getTripsDetails(trips, allTrips);
    if (tripsList.length === 0) return null;
    return (
      <section className="InfoWindowListaWyjazdow">
        <Glyphicon className="InfoWindowListaWyjazdow_icon" icon="place" />
        {tripsList.length > 1 ? "Wyjazdy" : "Wyjazd"}:
        <ul className="InfoWindowListaWyjazdow_list">
          {tripsList.map((trip: any) => (
            <li key={trip.id}>
              {trip.name}
              {!!trip.galleries &&
                trip.galleries.length > 0 &&
                trip.galleries.map((gallery: any) => (
                  <a
                    key={gallery.link}
                    className="InfoWindowListaWyjazdow_link"
                    title={"Zobacz galerię " + gallery.source}
                    href={gallery.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Glyphicon
                      icon="photo_camera"
                      className="InfoWindowListaWyjazdow_icon"
                    />
                  </a>
                ))}
              {!!trip.reports &&
                trip.reports.length > 0 &&
                trip.reports.map((report: any) => (
                  <a
                    key={report.link}
                    className="InfoWindowListaWyjazdow_link"
                    title={report.tittle}
                    href={report.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Glyphicon
                      icon="import_contacts"
                      className="InfoWindowListaWyjazdow_icon"
                    />
                  </a>
                ))}
            </li>
          ))}
        </ul>
      </section>
    );
  }
}

export default InfoWindowListaWyjazdow;
